import React from 'react';
import { Footer, TopControls } from '@/views/QueryBuilder/subcomponents';
import { RouterPresentationNavigation } from '@/features/dataPresentation/navigation/RouterPresentationNavigation';
import DataPresentationContainer from '@/containers/DataPresentationContainer';
import {
  useLoadColumns_LEGACY,
  useLoadRows_LEGACY,
  useLoadRowsCount_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import { CachedInfo } from '@/views/QueryBuilder/subcomponents/CachedInfo';
import { LoadMoreResults } from './subcomponents/LoadMoreResults';
import { LoadingError } from './subcomponents/LoadingError';
import { ContentContainer } from './QueryBuilder.styles';

const QueryContent = () => {
  useLoadColumns_LEGACY();
  useLoadRows_LEGACY();
  useLoadRowsCount_LEGACY();

  return (
    <ContentContainer>
      <TopControls />
      <RouterPresentationNavigation />
      <LoadMoreResults />
      <LoadingError />
      <CachedInfo />
      <DataPresentationContainer />
      <Footer />
    </ContentContainer>
  );
};

export default QueryContent;
